import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Surface } from "@/components/ds";
import {
  COLOR_KEYS, EMPTY_THEME, ThemeColorFields, ThemePresets, ThemePreviewCard,
  themeColorError, themeColorPayload,
} from "@/components/catalog/ThemeEditor";

/** Aparência do catálogo público principal. Não afeta as vitrines das criadoras. */
export const CatalogThemeSettings = ({ studioName }) => {
  const [form, setForm] = useState(EMPTY_THEME);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get("/settings/catalog-theme")
      .then(({ data }) => setForm({
        ...EMPTY_THEME, ...data.theme,
        ...Object.fromEntries(COLOR_KEYS.map((k) => [k, data.theme[k] || ""])),
      }))
      .catch((e) => toast.error(apiError(e)));
  }, []);

  const applyPreset = ([key, , ...colors]) =>
    setForm((f) => ({ ...f, theme_preset: key,
                      ...Object.fromEntries(COLOR_KEYS.map((k, i) => [k, colors[i]])) }));

  const save = async () => {
    const error = themeColorError(form);
    if (error) return toast.error(error);
    setBusy(true);
    try {
      await api.put("/settings/catalog-theme", themeColorPayload(form));
      toast.success("Aparência do catálogo atualizada.");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5" data-testid="catalog-theme-settings">
      <ThemePresets value={form.theme_preset} onApply={applyPreset}
                    testidPrefix="catalog-theme" />
      <Surface className="p-5">
        <p className="font-display text-base">Cores do catálogo principal</p>
        <p className="mt-1 text-[11px] text-muted-foreground">
          Vale apenas para o catálogo público da TR3ND. As vitrines das criadoras e o painel
          administrativo não são afetados. Deixe em branco para manter o tema padrão.
        </p>
        <div className="mt-4">
          <ThemeColorFields form={form} testidPrefix="catalog"
                            onChange={(key, value) => setForm((f) => ({ ...f, [key]: value }))} />
        </div>
        <div className="mt-5">
          <ThemePreviewCard form={form} title={studioName}
                            testid="catalog-theme-preview" />
        </div>
      </Surface>
      <Button onClick={save} disabled={busy} data-testid="catalog-theme-save-btn"
              className="h-11 w-full gap-2 rounded-full font-semibold sm:w-auto sm:px-8">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        Salvar aparência
      </Button>
    </div>
  );
};
